<template>
  <div class="bind-department-item-bd ubv ub-f1">
    <div class="ub" style="margin-bottom: 24px">
      <el-button type="warning" style="margin-right: 6px" :disabled="!isShowBind" @click="onBindEvent" v-if="funcView.depuser_location_join_dep">
        <i class="icon icon-tianjia"></i>
        <span>&ensp;{{ $t('bind_department_item.jia_ru_bu_men') }}</span>
      </el-button>
      <el-button style="margin-right: 16px" :disabled="!isShowUnbind" @click="onUnbindEvent" v-if="funcView.depuser_location_quit_dep">
        <i class="icon icon-shanchu"></i>
        <span>&ensp;{{ $t('bind_department_item.tui_chu_bu_men') }}</span>
      </el-button>
      <div class="ub-f1" style="margin-right: 12px" >
        <search-input width="100%" :placeholder="$t('bind_department_item.gong_si_ming_cheng')" v-model="formSearch.orgName" @fetch="onPageChange({ page: 1 })"></search-input>
      </div>
      <div class="ub-f1">
        <search-input width="100%" :placeholder="$t('Common.com_location_name')" v-model="formSearch.locationName" @fetch="onPageChange({ page: 1 })"></search-input>
      </div>
    </div>
    <div class="table-bd ub-f1">
      <custom-table height="100%" stripe type="checkbox" tableCode="portal_organ_location" v-model="tableSelect" :data="tableList"></custom-table>
    </div>
    <div class="table-page">
      <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
    </div>
    <!-- 选择部门 -->
    <bind-department-dialog v-if="dialogVisible" :model="dialogModel" :organ="organ" @close="dialogVisible = false" @success="getLocationList()"></bind-department-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import bindDepartmentDialog from './bind_department_dialog.vue';

export default {
  name: 'bind_department_item',
  components: { bindDepartmentDialog },
  props: {
    organ: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogModel: {},
      formSearch: {
        showSubsidiary: true,
        search: '',
        orgName: '',
        locationName: '',
        bizId: '',
        bizType: '',
        parentId: '',
        isAss: 1,
        pageSize: 50,
        pageNum: 1,
      },
      tableSelect: [],
      tableList: [],
      totalRows: 0,
    };
  },
  computed: {
    isShowBind() {
      return this.tableSelect.length > 0 && this.tableSelect.filter(t => t.departmentId).length === 0;
    },
    isShowUnbind() {
      return this.tableSelect.length > 0 && this.tableSelect.filter(t => !t.departmentId).length === 0;
    },
  },
  watch: {
    organ: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.deviceList = [];
      this.totalRows = 0;
      this.getLocationList();
    },
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getLocationList();
    this.getFuncView();
  },
  methods: {
    // 获取关联项目
    getLocationList: function () {
      if (!this.organ.bizId) {
        return;
      }
      this.formSearch.bizId = this.organ.bizId;
      this.formSearch.bizType = this.organ.bizType;
      this.formSearch.parentId = this.organ.orgId;
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.$getJSON(apis.deviceLocationPage, this.formSearch).then((res) => {
        this.tableList = res.data.list || [];
        this.totalRows = res.data.total;
      });
    },
    // 取消关联部门
    onUnbindEvent: function () {
      this.$showConfirm(this, this.$t('bind_department_item.nqdyjxzdxmtcqszdbm'))
        .then(() => {
          const params = this.tableSelect.map(t => ({
            orgId: null,
            bizId: t.departmentId,
            bizType: 2,
            toBizId: t.locationId,
            toBizType: 4,
          }));
          this.$postJSON(apis.organDeviceBindAutoDel, params).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getLocationList();
          });
        })
        .catch(() => {});
    },
    // 加入部门
    onBindEvent: function () {
      this.dialogModel.title = this.$t('bind_department_item.jia_ru_bu_men');
      this.dialogModel.tableSelect = this.tableSelect;
      this.dialogVisible = true;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getLocationList();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
</style>
